document.addEventListener('DOMContentLoaded', () => {
    import(/* webpackIgnore: true */ `/static/js/autoloader-conf.js?t=${Date.now()}`);
});